import React from "react";

const SpiritualDisciplines: React.FC = () => {
  const disciplines = [
    {
      title: "Integrity",
      desc: "Trusted to conduct honest self-assessment that God and others can trust.",
      icon: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
      colorClass: "bg-blue-50 text-blue-500 border-blue-100",
    },
    {
      title: "Reliability",
      desc: "When members of your group rest assured that you will not let them down.",
      icon: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z",
      colorClass: "bg-purple-50 text-purple-500 border-purple-100",
    },
    {
      title: "Diligence",
      desc: "Excelling by using my will and strength to achieve expected results.",
      icon: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0z",
      colorClass: "bg-pink-50 text-pink-500 border-pink-100",
    },
    {
      title: "Commitment",
      desc: "When you immerse yourself fully in a task because you know it pleases God.",
      icon: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z",
      colorClass: "bg-cyan-50 text-cyan-500 border-cyan-100",
    },
    {
      title: "New Self",
      desc: "Attitude of reading at least one chapter of the Bible and praying before going to work every day..",
      icon: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z",
      colorClass: "bg-orange-50 text-orange-500 border-orange-100",
    },
    {
      title: "Faithfulness",
      desc: "Enjoying the sacrifice of yourself to meet others' expectations.",
      icon: "M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z",
      colorClass: "bg-green-50 text-green-500 border-green-100",
    },
    {
      title: "Journaling",
      desc: "We encourage keeping note in your Bible of whatever thoughts the Lord has spoken..",
      icon: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z",
      colorClass: "bg-indigo-50 text-indigo-500 border-indigo-100",
    },
    {
      title: "Habit building.",
      desc: "It practically helps to build habit by repeating actions consistently.",
      icon: "M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z",
      colorClass: "bg-indigo-50 text-indigo-500 border-indigo-100",
    },
    // {
    //   title: "Self-assessment",
    //   desc: "Helps you effectively do an honest self-assessment of the level or state you are in.",
    //   icon: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
    //   colorClass: "bg-yellow-50 text-yellow-600 border-yellow-100",
    // },
  ];

  return (
    <section className="py-20 bg-gray-50/50">
      <div className="container mx-auto px-4 lg:px-16 text-center mb-16">
        <p className="text-navYellow font-medium tracking-wider text-xl mb-3">Spiritual Disciplines</p>
        <h2 className="text-3xl md:text-4xl font-semibold text-darkBlue">Other spiritual Disciplines you develop through CBR</h2>
      </div>

      <div className="container mx-auto px-4 lg:px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {disciplines.map((item, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mb-5 border ${item.colorClass}`}>
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                </svg>
              </div>
              <h3 className="font-semibold text-darkBlue text-lg mb-2">{item.title}</h3>
              <p className="text-gray-700 text-base leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SpiritualDisciplines;
